import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.8",
      d: "M6 15v4.5a1.5 1.5 0 1 0 3 0V15m-3 0h4m-4 0a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h4m0 0 9.622-3.928A1 1 0 0 1 21 3.998v13.995a1 1 0 0 1-1.377.926L10 15m0-8v8"
    }, null, -1)
  ])))
}
export default { render: render }